import { useEffect, useMemo, useReducer } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './App.scss'

// Design system theme — loads CSS custom properties for all @ubiquitel/ui components
import '../packages/ui/src/theme.scss';

import { RealtimeClient } from './services/realtime-client'
import { getSupabaseClient } from './services/supabase';
import { useAuth } from './auth/AuthProvider';
import { GlobalStateReducer, initialGlobalState } from './states/GlobalStateReducer'

import Dashboard from './pages/Dashboard';
import UbiSim from './pages/UbiSim';
import Devices from './pages/Devices';

// Set the design system theme on document root
document.documentElement.setAttribute('data-theme', 'theme-1');

function App() {
  const [state, dispatch] = useReducer(GlobalStateReducer, initialGlobalState);
  const { session } = useAuth();
  const realtimeClient = useMemo(() => {
    const supabase = getSupabaseClient();
    if (!supabase) throw new Error('Supabase client is not configured');
    return new RealtimeClient(supabase);
  }, []);

  useEffect(() => {
    realtimeClient.updateAuth(session?.access_token, session?.user?.id);
  }, [session?.access_token, session?.user?.id, realtimeClient]);

  useEffect(() => {
    return () => realtimeClient.destroy();
  }, [realtimeClient]);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Dashboard state={state} dispatch={dispatch} realtimeClient={realtimeClient} />} />
          <Route path="/sim" element={<UbiSim state={state} dispatch={dispatch} realtimeClient={realtimeClient} />} />
          <Route path="/devices" element={<Devices realtimeClient={realtimeClient} />} />
        </Routes>
      </BrowserRouter>
    </div>
  )
}

export default App
